import numberFilters from "JS/filters/numberFilters";
import socialFilters from "JS/filters/socialFilters";
import stringFilters from "JS/filters/stringFilters";

(function () {
    let util = {};

    util.isArray = function (obj) {
        return Array.isArray(obj);
    };

    let MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
    util.isArrayLike = function (obj) {
        if (typeof obj !== 'object' || !obj) {
            return false;
        }
        let length = obj.length;
        return typeof length === 'number' &&
            length % 1 === 0 && length >= 0 && length <= MAX_ARRAY_INDEX;
    };

    util.isObject = function (obj) {
        let type = typeof obj;
        return type === 'function' || type === 'object' && !!obj;
    };

    util.each = function (obj, callback) {
        let i,
            len;
        if (util.isArray(obj)) {
            for (i = 0, len = obj.length; i < len; i++) {
                if (callback(obj[i], i, obj) === false) {
                    break;
                }
            }
        } else {
            for (i in obj) {
                if (callback(obj[i], i, obj) === false) {
                    break;
                }
            }
        }
        return obj;
    };

    util.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
        util['is' + name] = function (obj) {
            return toString.call(obj) === '[object ' + name + ']';
        };
    });

    util.keys = function (obj) {
        if (!util.isObject(obj)) {
            return [];
        }
        if (Object.keys) {
            return Object.keys(obj);
        }
        let keys = [];
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                keys.push(key);
            }
        }
        return keys;
    };

    util.extend = function (target, source) {
        source = [].slice.call(arguments, 1);
        for (let i = 0; i < source.length; i++) {
            util.each(util.keys(source[i]), function (key) {
                target[key] = source[i][key];
            });
        }
        return target;
    };

    util.values = function (obj) {
        let keys = util.keys(obj);
        let length = keys.length;
        let values = new Array(length);
        for (let i = 0; i < length; i++) {
            values[i] = obj[keys[i]];
        }
        return values;
    };

    util.toArray = function (obj) {
        if (!obj) {
            return [];
        }
        if (util.isArrayLike(obj)) {
            return slice.call(obj);
        }
        return util.values(obj);
    };

    util.map = function (obj, cb) {
        let keys = !util.isArrayLike(obj) && util.keys(obj),
            length = (keys || obj).length,
            results = new Array(length);
        for (let index = 0; index < length; index++) {
            let currentKey = keys ? keys[index] : index;
            results[index] = cb(obj[currentKey], currentKey, obj);
        }
        return results;
    };

    util.get = function (obj, accessor) {
        let ret = undefined;
        if (!util.isObject(obj)) {
            return obj;
        }
        if (accessor == undefined) {
            return obj;
        }
        if (util.isString(accessor)) {
            accessor = accessor.split('.');
            ret = obj;
            try {
                for (let i = 0; i < accessor.length; i++) {
                    ret = ret[accessor[i]];
                }
            } catch (e) {
                ret = undefined;
            }
        } else if (util.isFunction(accessor)) {
            ret = accessor(obj);
        }
        return ret;
    };

}());

export default function install(Vue) {
    let filters = util.extend({},
        numberFilters,
        socialFilters,
        stringFilters
    );
    util.each(filters, function(value, key) {
        if (!Vue.filter(key)) {
            Vue.filter(key, value);
        }
    });
}
